import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  HostListener,
  Injector,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { StateStorageService } from 'app/core/auth/state-storage.service';
import { LoginService } from 'app/core/login/login.service';
import { DialogConfirmComponent } from 'app/dialog/dialog-confirm/dialog-confirm.component';
import { DialogHelpComponent } from 'app/dialog/dialog-help/dialog-help.component';
import { DialogSettingComponent } from 'app/dialog/dialog-setting/dialog-setting.component';
import { Common } from 'app/model/entity/common';
import { SaveMainStateAction } from 'app/ngrx-component-state-management/component-state.action';
import { CommonService } from 'app/service/common.service';
import { DataService } from 'app/service/data.service';
import { DialogService } from 'app/service/dialog.service';
import { ExecutingService } from 'app/service/executing.service';
import { UserService } from 'app/service/user.service';
import { AppState } from 'app/store/app.state';
import { Subject, interval, timer } from 'rxjs';
import { startWith, switchMap, takeUntil } from 'rxjs/operators';
import { AutoLogoutTime, Constant, FIELD_COMPONENT, TYPE_LAYOUT } from '../../config/constants';
import { LayoutComponent } from '../layout/layout.component';
import { Layout1Component } from '../layout1/layout1.component';
import { Layout2Component } from '../layout2/layout2.component';
import { Layout3Component } from '../layout3/layout3.component';
import { Layout4Component } from '../layout4/layout4.component';
import { Layout5Component } from '../layout5/layout5.component';
import { Layout6Component } from '../layout6/layout6.component';
import { SessionService } from 'app/service/session.service';
import { UserSettingService } from 'app/service/user-setting.service';
import { UserSetting } from 'app/model/entity/user-setting';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { CSRFService } from 'app/core/auth/csrf.service';
import { AuthServerProvider } from 'app/core/auth/auth-jwt.service';
import { error } from 'console';
import { Helper } from '../helper';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html'
})
/**
 * Class MainComponent
 */
export class MainComponent implements OnInit {
  countRequests: number = 0;
  timeoutCount: number = 0;
  private timeout = -1;
  private readonly resetTimerSubject = new Subject();
  private readonly stopIntervalSubject = new Subject();
  Constant = Constant;
  typeLayout: TYPE_LAYOUT = TYPE_LAYOUT.TYPE;
  TYPE_LAYOUT = TYPE_LAYOUT;
  componentRef: ComponentRef<any>;
  @ViewChild('moduleLayout', {
    read: ViewContainerRef,
    static: true
  })
  moduleLayout: any;
  projectName: string = '';
  username: string = '';
  timeOutId: any;
  commonObject: Common;
  /**
   * current layout
   */
  private currentLayout: TYPE_LAYOUT;
  private dataConfigCognito: any;
  /**
   * list value software depend on project
   */
  private static readonly VALUES_FIELD_COMPONENT_DEPEND_ON_PROJECT: any = [
    FIELD_COMPONENT.MediaManagerComponent,
    FIELD_COMPONENT.RouteListEditorComponent,
    FIELD_COMPONENT.DestinationSignEditorComponent,
    FIELD_COMPONENT.SignageDisplayEditorComponent,
    FIELD_COMPONENT.BusInformationDisplayEditorComponent,
    FIELD_COMPONENT.StationDisplayEditorComponent,
    FIELD_COMPONENT.DigitalSignageContentEditorComponent
  ];
  /**
   * name field component property
   */
  private static readonly FIELD_COMPONENT_1 = 'fieldComponent1';
  private static readonly FIELD_COMPONENT_2 = 'fieldComponent2';
  private static readonly FIELD_COMPONENT_3 = 'fieldComponent3';

  isSetupDataAnnouncement: boolean;
  isSavingLanguagePushNotification: boolean;

  /**
   * Get the code on the URL
   */
  codeParams: string = '';

  public readonly ACCESS_TOKEN_PARAM = 'access_token';
  public readonly REFRESH_TOKEN_PARAM = 'refresh_token';
  /**
   * create url search params
   */
  urlSearchParams: any;
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetectorRef: ChangeDetectorRef,
    private dataService: DataService,
    private dialogService: DialogService,
    private http: HttpClient,
    private injector: Injector,
    private executingService: ExecutingService,
    public readonly store: Store<AppState>,
    private loginService: LoginService,
    private stateStorageService: StateStorageService,
    private router: Router,
    private translateService: TranslateService,
    private userService: UserService,
    private sessionService: SessionService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private userSettingService: UserSettingService,
    public csrfService: CSRFService,
    private authServerProvider: AuthServerProvider
  ) {
    this.dataService.currentData.subscribe(data => {
      if (data[0] == 'userName') {
        this.username = <string>data[1] ?? '';
        // start counting for inactive time
        this.startTimer();
      }
    });
    this.dataService.currentData.subscribe(data => {
      if (data[0] == 'projectName') {
        this.projectName = <string>data[1] ?? '';
      }
    });
    this.dataService.currentData.subscribe(data => {
      if (data[0] == 'zoomOutScreen') {
        this.changeLayout(TYPE_LAYOUT.TYPE);
      }
    });
    this.executingService.executingRequest.subscribe(isLoadingData => {
      if (isLoadingData) {
        this.countRequests++;
      } else if (this.countRequests > 0) {
        this.countRequests--;
      }
    });
    this.dataService.resetLayoutAction.subscribe(isReset => {
      if (isReset) {
        this.resetComponentWhenDeleteProject();
      }
    });
    // this.resetTimerSubject.subscribe(() => {
    //   if (this.timeoutCount >= 60) {
    //     this.timeoutCount = 0;
    //     this.http.get(Constant.BACKEND_URL + 'auth/inactive').toPromise();
    //   }
    // });
    this.store
      .select(state => state)
      .subscribe((componentState: any) => {
        this.commonObject = componentState.mainState?.stateOfComponent.common ?? new Common();
        const setting = this.commonObject.setting;
        if (setting) {
          switch (setting.autoLogoutTime) {
            case AutoLogoutTime.FIVE_MINUTE:
              this.timeout = 5 * 60;
              break;
            case AutoLogoutTime.TEN_MINUTE:
              this.timeout = 10 * 60;
              break;
            case AutoLogoutTime.THIRSTY_MINUTE:
              this.timeout = 30 * 60;
              break;
            case AutoLogoutTime.ONE_HOUR:
              this.timeout = 60 * 60;
              break;
            case AutoLogoutTime.NEVER:
              this.timeout = -1;
              break;
            default:
              this.timeout = -1;
              break;
          }
        }
      });
    this.dataService.currentData.subscribe(data => {
      if (data[0] == Constant.IS_SETUP_DATA_ANNOUNCEMENT) {
        this.isSetupDataAnnouncement = data[1];
      }
    });
    this.dataService.currentData.subscribe(data => {
      if (data[0] == Constant.IS_SAVING_LANGUAGE_PUSH_NOTIFICATION) {
        this.isSavingLanguagePushNotification = data[1];
      }
    });
  }

  @HostListener('window:click', ['$event'])
  onMouseClicked(event) {
    this.resetTimer();
  }

  @HostListener('window:keydown', ['$event'])
  onKeyPressed(event) {
    this.resetTimer();
  }

  @HostListener('window:mousewheel', ['$event'])
  onMouseScrolled(event) {
    this.resetTimer();
  }

  ngOnInit(): void {
    this.getCognitoConfig();

    this.changeDetectorRef.detectChanges();
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event) {
    if ((window as any).skipBeforeUnload || (window as any).forceLogout) {
      return true;
    }
    this.store
      .select(state => state)
      .subscribe((componentState: any) => {
        this.commonObject = componentState?.mainState?.stateOfComponent?.common ?? new Common();
        delete this.commonObject.isLogout;
        delete this.commonObject.isLoadedFonts;
        if (Object.values(this.commonObject).every(object => !object)) {
          return;
        }
        this.commonObject.privileges = componentState?.userInfoState?.stateOfComponent.privileges;
        this.commonObject.user = componentState?.userInfoState?.stateOfComponent.user;
        sessionStorage.setItem(Constant.COMMON_INFORMATION, JSON.stringify(this.commonObject));
      });
    if (
      this.checkChangeDataWhenReload('componentRef') ||
      this.checkChangeDataWhenReload('componentRef2') ||
      this.checkChangeDataWhenReload('componentRef3')
    ) {
      var confirmationMessage = 'o/';
      (event || window.event).returnValue = confirmationMessage;
      return confirmationMessage;
    }
    return true;
  }

  /**
   * check change data when reload
   *
   * @param componentRefName
   * @returns
   */
  checkChangeDataWhenReload(componentRefName: string) {
    return (
      this.componentRef.instance[componentRefName]?.instance?.isChangedData ||
      this.componentRef.instance[componentRefName]?.instance?.isChangedNewsTab ||
      this.componentRef.instance[componentRefName]?.instance?.isChangedWeatherTab ||
      this.componentRef.instance[componentRefName]?.instance?.isChangeMediaOfSequence ||
      this.componentRef.instance[componentRefName]?.instance?.isShowFreeArea ||
      this.componentRef.instance[componentRefName]?.instance?.isChangeAudioOfSequence ||
      this.componentRef.instance[componentRefName]?.instance?.isChangeCommonRegistration ||
      this.componentRef.instance[componentRefName]?.instance?.isChangeSpecificRegistration
    );
  }

  /**
   * Change layout
   * @param typeLayout TYPE_LAYOUT
   */
  changeLayout(typeLayout: TYPE_LAYOUT) {
    this.currentLayout = typeLayout;
    sessionStorage.setItem(Constant.LAYOUT, `${typeLayout}`);
    switch (typeLayout) {
      case TYPE_LAYOUT.TYPE:
        this.createComponent(LayoutComponent);
        break;
      case TYPE_LAYOUT.TYPE1:
        this.createComponent(Layout1Component);
        break;
      case TYPE_LAYOUT.TYPE2:
        this.createComponent(Layout2Component);
        break;
      case TYPE_LAYOUT.TYPE3:
        this.createComponent(Layout3Component);
        break;
      case TYPE_LAYOUT.TYPE4:
        this.createComponent(Layout4Component);
        break;
      case TYPE_LAYOUT.TYPE5:
        this.createComponent(Layout5Component);
        break;
      case TYPE_LAYOUT.TYPE6:
        this.createComponent(Layout6Component);
        break;
      default:
        break;
    }
  }

  /**
   * reset component depend on project when delete project
   */
  private resetComponentWhenDeleteProject(): void {
    // set field component 1
    this.setFieldComponent(MainComponent.FIELD_COMPONENT_1);
    // set field component 2
    this.setFieldComponent(MainComponent.FIELD_COMPONENT_2);
    // set field component 3
    this.setFieldComponent(MainComponent.FIELD_COMPONENT_3);
    this.store.dispatch(
      new SaveMainStateAction({
        common: this.commonObject
      })
    );
    this.changeLayout(this.currentLayout);
  }

  /**
   * rest field component for common object
   * @param fieldComponentName
   * @returns
   */
  private setFieldComponent(fieldComponentName: string): void {
    if (!this.commonObject || !this.commonObject[fieldComponentName]) {
      return;
    }
    let fieldComponent = this.commonObject[fieldComponentName].split('-')[0];
    if (fieldComponent === undefined || !MainComponent.VALUES_FIELD_COMPONENT_DEPEND_ON_PROJECT.includes(+fieldComponent)) {
      return;
    }
    this.commonObject[fieldComponentName] = undefined;
  }

  createComponent(layout) {
    const factory = this.componentFactoryResolver.resolveComponentFactory(layout);
    this.moduleLayout.clear();
    this.componentRef = this.moduleLayout.createComponent(factory, null, this.injector);
    this.changeDetectorRef.detectChanges();
    this.dataService.sendData([Constant.UPDATE_VIEW_BY_PRIVILEGES, null]);
  }

  /**
   * get layout
   * @param layout
   * @returns
   */
  private getLayout(layout: number): any {
    switch (layout) {
      case 0:
        return LayoutComponent;
      case 1:
        return Layout1Component;
      case 2:
        return Layout2Component;
      case 3:
        return Layout3Component;
      case 4:
        return Layout4Component;
      case 5:
        return Layout5Component;
      case 6:
        return Layout6Component;
      default:
        return LayoutComponent;
    }
  }

  /**
   * setting
   */
  setting() {
    this.dialogService.showDialog(DialogSettingComponent);
  }

  /**
   * handle logout
   */
  logout(): void {
    this.dialogService.showDialog(
      DialogConfirmComponent,
      {
        data: {
          text: this.translateService.instant('main.logout-dialog.title'),
          button1: this.translateService.instant('main.logout-dialog.yes'),
          button2: this.translateService.instant('main.logout-dialog.no')
        }
      },
      result => {
        if (result) {
          this.loginService.logout();
          this.loginService.cognitoLogout(this.commonObject);
        }
      }
    );
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  resetTimer() {
    this.resetTimerSubject.next();
  }

  startTimer() {
    interval(1000)
      .pipe(takeUntil(this.stopIntervalSubject))
      .subscribe(() => {
        this.timeoutCount++;
        if (this.timeout != -1 && this.timeoutCount > this.timeout) {
          this.stopIntervalSubject.next();
          this.stopIntervalSubject.unsubscribe();
          this.resetTimerSubject.unsubscribe();
          alert('Session timed out. Reload to login again.');
          this.loginService.logout();
          this.loginService.cognitoLogout(this.commonObject);
        }
      });
    this.resetTimerSubject
      .pipe(
        startWith(0),
        switchMap(() => timer(10000))
      )
      .subscribe(() => {
        this.timeoutCount = 0;
        this.http.get(Constant.BACKEND_URL + 'auth/inactive').toPromise();
      });
  }

  /**
   * show manual
   */
  public showManual(): void {
    this.dialogService.showDialog(DialogHelpComponent, {
      data: {
        commonObject: this.commonObject
      }
    });
  }

  /**
   * Exchange Code For Token
   */
  exchangeCodeForToken(code: string, params: any) {
    if (!code) {
      return;
    }
    let csrfToken = this.csrfService.getCSRF();
    this.userService.getTokenCognito(code, csrfToken).subscribe(
      data => {
        let token = data.token_cognito;
        if (data && token.refresh_token && token.access_token && token.id_token) {
          const payload = Helper.decodeToken(token.id_token);
          this.commonObject.tenantName = payload['custom:tenant_id'].toLowerCase();
          this.commonObject.userName = payload['nickname'];
          this.commonObject.dataConfigCognito = params;
          this.commonObject.urlSearchParams = this.urlSearchParams.toString();
          this.commonObject.infoUser = payload;
          this.setStorage('access_token', token.id_token);
          this.setStorage('refresh_token', token.refresh_token);
          this.setStorage('id_token_cognito', token.id_token);
          this.setStorage('access_token_cognito', token.access_token);
          if (window.location.href.includes('?')) {
            this.router.navigate(['']);
          }
          forkJoin([this.userSettingService.getInfoSetting(), this.userSettingService.getAllTimeZone()]).subscribe(dataResponses => {
            let userSettingData = dataResponses[0];
            let listTimeZone = dataResponses[1];
            if (userSettingData) {
              let userSetting: UserSetting = userSettingData;
              userSetting.timezone = listTimeZone.find(timezone => timezone.id == +userSettingData['timezone']);
              this.commonObject.setting = userSetting;
              if (this.commonObject.setting?.language) {
                this.translateService.use(this.commonObject.setting.language);
              }
              this.sessionService.checkConcurrentSessions().subscribe(
                response => {
                  if (response.hasConcurrentSameUsers || response.hasConcurrentDifferentUsers) {
                    if (!this.commonObject.infoUser['custom:superuser']) {
                      let messageKey: string;
                      let button1Key: string;
                      let button2Key: string;

                      if (response.hasConcurrentDifferentUsers) {
                        messageKey = 'common.concurrent-warning-different-userid';
                        button1Key = 'common.yes';
                        button2Key = 'common.no';
                      } else if (response.hasConcurrentSameUsers && !response.hasConcurrentDifferentUsers) {
                        messageKey = 'common.concurrent-warning-same-userid';
                        button1Key = 'common.forced-log-in';
                        button2Key = 'common.cancel';
                      }

                      this.dialogService.showDialog(
                        DialogConfirmComponent,
                        {
                          data: {
                            text: this.translateService.instant(messageKey),
                            button1: this.translateService.instant(button1Key),
                            button2: this.translateService.instant(button2Key)
                          }
                        },
                        result => {
                          if (result) {
                            this.createSessionAndProceed();
                          } else {
                            this.loginService.redirectCognitoLogin(this.dataConfigCognito, this.urlSearchParams);
                          }
                        }
                      );
                    } else {
                      this.createSessionAndProceed();
                    }
                  } else {
                    this.createSessionAndProceed();
                  }
                },
                error => {
                  this.loginService.redirectCognitoLogin(this.dataConfigCognito, this.urlSearchParams);
                }
              );
            }
          });
        } else {
          this.loginService.redirectCognitoLogin(this.dataConfigCognito, this.urlSearchParams);
        }
      },
      error => {
        throw new Error(`HTTP error! Status: ${error}`);
      }
    );
  }

  /**
   * createSessionAndProceed
   */
  private createSessionAndProceed() {
    this.sessionService.createSession().subscribe(
      sessionResponse => {
        if (sessionResponse.status === 'created') {
          this.commonObject.sessionId = sessionResponse.sessionId;
          this.store.dispatch(
            new SaveMainStateAction({
              common: this.commonObject
            })
          );
          sessionStorage.setItem(Constant.COMMON_INFORMATION, JSON.stringify(this.commonObject));
          this.openComponent();
        } else {
          this.loginService.redirectCognitoLogin(this.dataConfigCognito, this.urlSearchParams);
        }
      },
      error => {
        this.loginService.redirectCognitoLogin(this.dataConfigCognito, this.urlSearchParams);
      }
    );
  }

  /**
   * openComponent
   */
  openComponent(): void {
    setTimeout(() => {
      const factory = this.componentFactoryResolver.resolveComponentFactory(this.getLayout(+sessionStorage.getItem(Constant.LAYOUT) || 0));
      this.componentRef = this.moduleLayout.createComponent(factory);
    }, 100);
  }

  /**
   * checkSetting
   */
  public checkSetting(): boolean {
    if (this.commonObject?.userIdString == 'root') {
      return true;
    }
    const token = sessionStorage.getItem('id_token_cognito');
    const payload = Helper.decodeToken(token);
    if (payload?.['custom:superuser'] == true || payload?.['custom:role_id'] == '1') {
      return true;
    }
    return false;
  }

  /**
   * Save the token to the browser
   */
  private setStorage(name: string, value: string): void {
    const expires = new Date();
    expires.setTime(expires.getTime() + 60 * 60 * 1000);
    sessionStorage.setItem(name, value);
  }

  /**
   * Get data config Cognito
   */
  getCognitoConfig(): void {
    const url = `${Constant.BACKEND_URL}auth/cognito-enviroment-variable`;
    const headers = new Headers({
      'Content-Type': 'application/json'
    });
    let language = this.activatedRoute.snapshot.params.language;
    fetch(url, {
      method: 'GET',
      headers: headers
    })
      .then(response => response.json())
      .then(res => {
        this.urlSearchParams = new URLSearchParams({
          client_id: res.clientId,
          redirect_uri: res.redirectUri,
          response_type: 'code',
          lang: language ?? 'ja'
        });
        let urlNow = window.location.href;
        this.dataConfigCognito = res;
        const accessToken = sessionStorage.getItem('access_token');

        if (urlNow.includes('?code') && !accessToken) {
          this.codeParams = urlNow.split('=')[1];
          this.exchangeCodeForToken(this.codeParams, res);
        } else {
          const token = sessionStorage.getItem('id_token_cognito');
          const payload = token ? Helper.decodeToken(token) : null;
          if (payload) {
            this.commonObject.tenantName = payload['custom:tenant_id'].toLowerCase();
            this.commonObject.infoUser = payload;
            const factory = this.componentFactoryResolver.resolveComponentFactory(
              this.getLayout(+sessionStorage.getItem(Constant.LAYOUT) || 0)
            );
            this.componentRef = this.moduleLayout.createComponent(factory);
          }
          if (!accessToken || accessToken === 'undefined' || accessToken === null) {
            sessionStorage.clear();
            this.loginService.redirectCognitoLogin(this.dataConfigCognito, this.urlSearchParams);
          }
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
}
